import React, { useEffect, useState } from 'react'

import { SectionHeader } from '@react/components/common/SectionHeader'
import { useOtChainState, useOtSelector } from '@react/redux/store'
import { REPORT_FETCH_DESCRIPTOR_WITHDRAW_EVENTS_ALL_LENDERS } from '@react/reporting/ReportDescriptors'
import { ReportExplorer } from '@react/reporting/ReportExplorer'
import { ReportRowGeneratorClass } from '@react/reporting/ReportRowGeneratorClass'
import { ETH_ADDR_ZERO, EthAddr } from '@shared/SchemaTypes'
import { AdminBorrowerWithdrawalsFlexList } from './AdminBorrowerWithdrawalsFlexList'
import ReportDateRangeSelector from '@react/reporting/ReportDateRangePicker'
import dayjs, { Dayjs } from 'dayjs'

export const AdminWithdrawalFlexTab = (props: { poolAddr: EthAddr }): React.ReactElement => {
  const [, forceRerender] = useState({})
  const {
    chainConfiguration: { providerReadOnly, chainTimestampDelta },
    stageConfiguration: { serverApiBaseUrl, restAPIKey },
  } = useOtChainState()
  const poolBaseOverviewCTO = useOtSelector(
    (state) => state.poolState.poolOverviewCTOs[props.poolAddr ?? ETH_ADDR_ZERO]
  )
  const [dateRange, setDateRange] = useState<[Dayjs, Dayjs]>([
    dayjs().utc().subtract(30, 'day').add(chainTimestampDelta, 'seconds').startOf('day'),
    dayjs().add(chainTimestampDelta, 'seconds').utc(),
  ])

  const [reportRowGeneratorClass, setReportRowGeneratorClass] = useState<ReportRowGeneratorClass | undefined>(undefined)

  useEffect(() => {
    if (poolBaseOverviewCTO && providerReadOnly) {
      const _reportRowGeneratorClass = new ReportRowGeneratorClass({
        reportDescriptor: REPORT_FETCH_DESCRIPTOR_WITHDRAW_EVENTS_ALL_LENDERS,
        providerReadOnly,
        serverApiBaseUrl,
        restAPIKey,
        poolAddr: props.poolAddr,
        lenderAddr: undefined,
        dateRange,
      })
      setReportRowGeneratorClass(_reportRowGeneratorClass)
      _reportRowGeneratorClass.refreshData().then(() => {
        forceRerender({})
      })
    }
  }, [poolBaseOverviewCTO])

  return (
    <>
      <AdminBorrowerWithdrawalsFlexList />
      <SectionHeader>Withdrawal Ledger</SectionHeader>
      <ReportDateRangeSelector
        selectedPoolAddrs={props.poolAddr ? [props.poolAddr] : []}
        onSelectedChange={(_dayRange: [Dayjs, Dayjs]) => {
          setDateRange(_dayRange)
          reportRowGeneratorClass?.refreshData().then(() => {
            forceRerender({})
          })
        }}
        forEvents={true}
        initialDateRange={dateRange}
      />
      {reportRowGeneratorClass && <ReportExplorer reportRowGeneratorClass={reportRowGeneratorClass} />}
    </>
  )
}
